import tableWrapper from './components/table-wrapper';

const tables = document.getElementsByTagName('table');
if (tables && tables.length) {
  [...tables].forEach(table => tableWrapper(table));
}
